export default __webpack_public_path__ + "assets/d1ad476c0bff48e75ec9bf36418add9b.svg";